import { LegalArea } from "@/core/types/types";
import Cookies from "js-cookie";

export const pushCamundaFirstStepViewVariable = (
  stepTitle: string,
  processId: string
) => {
  const legalArea = Cookies.get("legalArea");
  if (
    processId &&
    stepTitle === "step-lead-01-airports" &&
    legalArea === LegalArea.APR
  ) {
    fetch(`api/updateProcessVariables`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: { firstStepView: stepTitle } }),
    }).then();
  }
};
